import { Box } from '@mantine/core';
import { type ReactElement } from 'react';

interface InitialAvatarProps {
    /** Text the initial is derived from (e.g. display name, falling back to email). */
    source: string;
    size?: number;
    variant?: 'outline' | 'filled';
}

/**
 * Square avatar showing the uppercased first character of `source`.
 * `outline` (default) sits on the surface with a border; `filled` uses the
 * primary color with white text. Used in tables, drawers, menus, and the nav.
 */
export default function InitialAvatar({ source, size = 28, variant = 'outline' }: InitialAvatarProps): ReactElement {
    const initial = (source.trim().charAt(0) || '?').toUpperCase();
    const filled = variant === 'filled';

    return (
        <Box
            style={{
                width: size,
                height: size,
                background: filled ? 'var(--mantine-primary-color-filled)' : 'var(--bm-color-surface)',
                border: filled ? 'none' : '1px solid var(--bm-color-border)',
                borderRadius: 'var(--bm-radius)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: filled ? 'white' : undefined,
                fontSize: Math.round(size * 0.38),
                fontWeight: 700,
                flexShrink: 0,
            }}
        >
            {initial}
        </Box>
    );
}
